/**
 * @author ASDS Team
 * @description Contains common logic accross all files that falls under action creators.
 */
class Action {

}

export default Action;